import styled, { css } from 'styled-components'
import { Box, Button, DropdownItem } from '@sketch/components'

export const TriggerButton = styled(Button).attrs({ size: '32' })(
  ({ theme }) => css`
    padding: 6px 8px 6px 12px; /* stylelint-disable-line scales/space */
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.regular};
    box-shadow: none;

    &,
    :hover,
    :focus,
    :active {
      color: ${theme.colors.foreground.secondary.A};
    }

    &[disabled] {
      opacity: 0.5;
    }

    &[aria-expanded='true'],
    &[aria-current='true'],
    &.active {
      border: 1px solid ${theme.colors.sketch.F};
      background-color: ${theme.colors.sketch.F};
      color: ${theme.colors.sketch.A};

      &:hover {
        background-color: ${theme.colors.sketch.F};
      }
    }
  `
)

export const DropdownItemStyled = styled(DropdownItem)(
  ({ theme }) => css`
    font-weight: ${theme.fontWeights.semibold};
  `
)

export const DropdownHeader = styled(Box)(
  ({ theme }) => css`
    margin-left: 20px;
    padding: 8px 0;

    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.B};
    font-weight: ${theme.fontWeights.regular};

    text-align: left;
    pointer-events: none;
  `
)

export const DropdownItemDescription = styled.span(
  ({ theme }) => css`
    display: block;
    margin: 4px 0 0 0;
    line-height: 1.2;
    white-space: initial;
    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.C};
    font-weight: ${theme.fontWeights.regular};
  `
)
